/**
 * <glasses-customizer> — personalizador de lentes, fluxo oficial Lolla Mundi (visual Zeno).
 *
 * Fluxos:
 *   grau:     categoria → grau → espessura → tratamento → receita → revisao
 *   descanso: categoria → descanso → (cor, se solar sem grau) → revisao
 *   solar:    armação comum: categoria → grau → espessura → cor → receita → revisao (espessuras da faixa em
 *             range.solar; cores do produto "solar sem grau", anotadas no pedido)
 *             óculos de sol (data-solar-frame): categoria → espessura → receita → revisao (sem faixa e sem cor:
 *             todas as espessuras de map.solar.tiers; a lente sai igual à foto). Só "Solar com grau" ou "Só a armação".
 *   Armação "so policarbonato" (data-only-poli): só lentes de policarbonato, em qualquer uso.
 *
 * Dados: um produto Shopify por faixa de grau (map.ranges[].handle). As variantes desse produto
 * são "Material / Tratamento-marca". Preço, marcas e estoque vêm de /products/<handle>.js.
 * Faixas e opções sem produto cadastrado viram "Fale no WhatsApp".
 *
 * Eager, AbortController via EssenceBaseComponent. Sem shopify:section:load.
 */
(function () {
  "use strict";

  if (!window.EssenceBaseComponent) return;

  var MATS = {
    "1.50": "CR-39 1.50",
    "1.56": "Resina 1.56",
    poli: "Policarbonato 1.59",
    "1.61": "Resina 1.61",
    "1.67": "Resina 1.67",
    "1.70": "Resina 1.70",
    "1.74": "Resina 1.74",
  };
  var MAT_ORDER = ["1.50", "1.56", "poli", "1.61", "1.67", "1.70", "1.74"];
  var THICK = { "1.50": 15, "1.56": 14, poli: 12, "1.61": 9, "1.67": 7, "1.70": 6, "1.74": 5 };
  var TIER_NAMES = ["Padrão", "Intermediária", "Fina", "Extra fina"];

  /* Tratamentos: nome e etiquetas. As mesmas etiquetas valem na etapa com grau e na sem grau ("sol" = solar sem grau). */
  var TREATS = {
    azul: { name: "Blue Light", best: true, badge: "Para quem usa telas", tags: ["Filtra a luz azul", "Menos cansaço visual", "Antirreflexo e UV"] },
    ar: { name: "Simples", tags: ["Antirreflexo e UV", "Uso diário", "Lente transparente"] },
    foto: { name: "Fotossensível", tags: ["Escurece no sol", "Clareia em ambientes internos", "Antirreflexo e UV"] },
    azulFoto: { name: "Blue Light + Fotossensível", tags: ["Filtra a luz azul", "Escurece no sol", "Antirreflexo e UV"] },
    sol: { name: "Solar", tags: ["Cor total ou degradê", "Escolha a cor", "Proteção UV"] },
  };
  var TREAT_ORDER = ["azul", "ar", "foto", "azulFoto"];
  var FRAME_ONLY_LENS = "Plástico padrão de fábrica (sem grau)";

  var COLOR_HEX = { preto: "#222222", cinza: "#555555", marrom: "#A57D38", verde: "#2f6b3a", azul: "#1e3a8a", "azul claro": "#7cb8ff", "amarelo claro": "#fde68a", "amarelo (night drive)": "#f5c518", roxo: "#6d28d9", vermelho: "#b91c1c", laranja: "#ea580c", rosa: "#ec4899" };

  var CHEV_SVG =
    '<svg class="zl-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>';
  var CHECK_SVG =
    '<svg class="zl-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var WA_SVG =
    '<svg class="zl-icon zl-icon--wa" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>';
  var LOCK_SVG =
    '<svg class="zl-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
  var IMG_SVG =
    '<svg class="zl-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>';

  /* ───────────────────────── helpers ───────────────────────── */

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function reais(cents) {
    var v = (Math.round(Number(cents) || 0)) / 100;
    return v.toLocaleString("pt-BR", {
      minimumFractionDigits: v % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
  }

  function money(cents) {
    return "R$ " + reais(cents);
  }

  function parseJSON(text, fallback) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return fallback;
    }
  }

  function fmtGrau(n) {
    return Number(n).toFixed(2).replace(".", ",");
  }

  /* Perfil da lente na etapa de espessura. A largura vem da POSIÇÃO na faixa (1ª = padrão, a mais grossa; cada
     seguinte mais fina), não do material: o mesmo material é a fina numa faixa e a padrão em outra. */
  var PROFILE_W = [22, 15, 10, 7, 5];
  var PROFILE_NOTE_FIRST = "Boa nitidez, o menor preço";
  var PROFILE_NOTE_LAST = "A mais fina e leve para o seu grau";
  var PROFILE_NOTES = ["Um pouco mais fina que a padrão", "Mais fina que a padrão", "Bem mais fina e leve", "Quase a mais fina"];
  function lensProfilePath(i) {
    var w = PROFILE_W[Math.min(i, PROFILE_W.length - 1)];
    var a = 26 - w / 2;
    var b = 26 + w / 2;
    return "M" + a + " 6 C " + (a + 12) + " 30, " + (a + 12) + " 60, " + a + " 84 L " + b + " 84 C " + (b + 12) + " 60, " + (b + 12) + " 30, " + b + " 6 Z";
  }

  /* Detecta o material pelo valor da opção da variante ("Resina 1.56", "Policarbonato", "CR-39"…). */
  function matOf(value) {
    var s = String(value || "").toLowerCase().replace(",", ".");
    if (/polic|1\.59/.test(s)) return "poli";
    var m = s.match(/1\.(5\d|6\d|7\d)/);
    if (m) return "1." + m[1];
    if (/cr-?39/.test(s)) return "1.50";
    return null;
  }

  /* Detecta o tipo de tratamento pelo nome da variante ("Kodak Blue", "Transitions", "Simples"…). */
  function treatOf(name) {
    var n = String(name || "").toLowerCase();
    var blue = /blue|azul|city|sapphire|eyezen|prevencia/.test(n);
    var foto = /foto|photo|transitions|sensity|photofusion/.test(n);
    if (blue && foto) return "azulFoto";
    if (blue) return "azul";
    if (foto) return "foto";
    return "ar";
  }

  function fabOf(name) {
    var n = String(name || "").toLowerCase();
    if (/kodak/.test(n)) return "Kodak";
    if (/crizal|essilor|varilux|airwear/.test(n)) return "Essilor";
    if (/transitions/.test(n)) return "Transitions";
    if (/zeiss/.test(n)) return "Zeiss";
    if (/hoya/.test(n)) return "Hoya";
    return "Lollamundi";
  }

  /* ───────────────────────── componente ───────────────────────── */

  class GlassesCustomizer extends EssenceBaseComponent {
    get eagerInit() {
      return true;
    }

    $(sel) {
      return (this.dialog || this).querySelector(sel);
    }

    $all(sel) {
      return (this.dialog || this).querySelectorAll(sel);
    }

    init() {
      this.dialog = HTMLElement.prototype.querySelector.call(this, "[data-gc-dialog]");
      this.map = parseJSON((HTMLElement.prototype.querySelector.call(this, "[data-glasses-map]") || {}).textContent || "{}", {});
      this.product = parseJSON((HTMLElement.prototype.querySelector.call(this, "[data-glasses-product]") || {}).textContent || "{}", {});
      this.gifs = parseJSON((HTMLElement.prototype.querySelector.call(this, "[data-glasses-gifs]") || {}).textContent || "{}", {});
      this.upsell = parseJSON((HTMLElement.prototype.querySelector.call(this, "[data-glasses-upsell]") || {}).textContent || "{}", {});
      this.whatsapp = this.dataset.whatsapp || "";
      this.maxGrau = parseFloat(String(this.dataset.maxGrau || "12").replace(",", ".")) || 12;
      this.solarFrame = this.dataset.solarFrame === "true";
      this.onlyPoli = this.dataset.onlyPoli === "true";
      this.state = this.defaultState();
      this.catalog = { ranges: {}, descanso: {}, solar: null, loading: false, loaded: false };
      this._productCache = {};
      this._lastFocus = null;
      this._submitting = false;
      this._home = null;
      this._focusHandler = this.onFocusTrap.bind(this);
      this.bind();
      this.hydrateKitCopy();
      this.syncPreview();
      this.render();
    }

    defaultState() {
      return {
        step: "categoria",
        category: "",
        range: "",
        mat: "",
        trat: "",
        opt: "", // id da variante da lente (marca)
        desc: "",
        corTipo: "",
        cor: "",
        rxMethod: "",
        rxFile: null,
        // A oferta nunca vem marcada: o cliente toca em "Adicionar" (evita venda casada).
        addKit: false,
        finder: { esf: "", cil: "" },
      };
    }

    /* ───────────── eventos ───────────── */

    bind() {
      var signal = this.__tdController.signal;
      var self = this;

      document.addEventListener(
        "click",
        function (e) {
          var opener = e.target.closest("[data-glasses-open]");
          if (!opener) return;
          var pid = opener.getAttribute("data-product-id");
          if (pid && String(pid) !== String(self.product.id)) return;
          e.preventDefault();
          self.open();
        },
        { signal: signal }
      );

      if (!this.dialog) return;

      this.dialog.addEventListener(
        "click",
        function (e) {
          if (e.target.closest("[data-gc-confirm-stay]") || e.target.matches("[data-gc-confirm]")) {
            e.preventDefault();
            self.hideConfirm(true);
            return;
          }
          if (e.target.closest("[data-gc-confirm-leave]")) {
            e.preventDefault();
            self.close();
            return;
          }
          if (e.target.closest(".zl__btn-close")) {
            e.preventDefault();
            self.requestClose();
            return;
          }
          if (e.target.closest("[data-gc-back]")) {
            e.preventDefault();
            self.go(-1);
            return;
          }
          if (e.target.closest("[data-gc-next]")) {
            e.preventDefault();
            self.next();
            return;
          }
          if (e.target.closest("[data-gc-view-cart]")) {
            e.preventDefault();
            self.submit("continuar");
            return;
          }
          if (e.target.matches("[data-gc-modal]")) {
            e.preventDefault();
            self.closeModal();
            return;
          }
          var actionBtn = e.target.closest("[data-action]");
          if (actionBtn && self.dialog.contains(actionBtn)) {
            if (actionBtn.tagName === "A") return; // link do WhatsApp: deixa navegar
            e.preventDefault();
            if (actionBtn.hasAttribute("disabled")) return;
            self.pick(actionBtn.getAttribute("data-action"), actionBtn.getAttribute("data-value"));
          }
        },
        { signal: signal }
      );

      this.$all("[data-gc-finder]").forEach(function (input) {
        input.addEventListener(
          "input",
          function () {
            self.state.finder[input.getAttribute("data-gc-finder")] = input.value;
            self.renderFinder();
          },
          { signal: signal }
        );
      });

      var file = this.$("#zlRxFile");
      if (file) {
        file.addEventListener(
          "change",
          function () {
            self.state.rxFile = file.files && file.files[0] ? file.files[0] : null;
            self.state.rxMethod = self.state.rxFile ? "upload" : "";
            self.clearError();
            self.render();
          },
          { signal: signal }
        );
      }

      document.addEventListener(
        "keydown",
        function (e) {
          if (e.key === "Escape" && self.isOpen()) {
            e.preventDefault();
            if (self.confirmOpen()) self.hideConfirm(true);
            else if (self.modalOpen()) self.closeModal();
            else self.requestClose();
          }
        },
        { signal: signal }
      );

      document.querySelectorAll('form[data-product-id="' + this.product.id + '"] input[name="id"]').forEach(function (input) {
        input.addEventListener(
          "change",
          function () {
            self.syncPreview();
            self.renderHeader();
          },
          { signal: signal }
        );
      });
    }

    /* ───────────── catálogo (produtos de lente) ───────────── */

    async resolveProduct(handle) {
      if (!handle) return null;
      if (this._productCache[handle] !== undefined) return this._productCache[handle];
      try {
        var res = await fetch("/products/" + encodeURIComponent(handle) + ".js");
        if (!res.ok) {
          this._productCache[handle] = null;
          return null;
        }
        var json = await res.json();
        this._productCache[handle] = json;
        return json;
      } catch (e) {
        this._productCache[handle] = null;
        return null;
      }
    }

    /* Índices das opções: qual é material e qual é tratamento/marca. */
    optionIndexes(product) {
      var names = (product.options || []).map(function (o) {
        return String(typeof o === "string" ? o : o && o.name ? o.name : "").toLowerCase();
      });
      var matIdx = -1;
      var tratIdx = -1;
      names.forEach(function (n, i) {
        if (matIdx < 0 && /material|resina|espess|índice|indice/.test(n)) matIdx = i;
        else if (tratIdx < 0 && /trat|marca|lente|tipo|acabamento/.test(n)) tratIdx = i;
      });
      if (matIdx < 0 || tratIdx < 0) {
        // Fallback: detecta pelos valores das variantes.
        var variants = product.variants || [];
        var scores = [0, 0, 0];
        variants.forEach(function (v) {
          [v.option1, v.option2, v.option3].forEach(function (val, i) {
            if (matOf(val)) scores[i] += 1;
          });
        });
        if (matIdx < 0) {
          var best = 0;
          scores.forEach(function (s, i) {
            if (s > scores[best]) best = i;
          });
          matIdx = scores[best] > 0 ? best : -1;
        }
        if (tratIdx < 0) {
          var count = (product.options || []).length || 1;
          for (var i = 0; i < count; i++) {
            if (i !== matIdx) {
              tratIdx = i;
              break;
            }
          }
        }
      }
      return { mat: matIdx, trat: tratIdx };
    }

    /* Transforma o produto da faixa em { mats: { '1.56': { label, tier, brands: [...] } } } */
    hiddenSku(v) {
      var prefixes = this.map.hideSkuPrefixes || [];
      var sku = String((v && v.sku) || "").trim().toUpperCase();
      return prefixes.some(function (p) {
        return p && sku.indexOf(String(p).toUpperCase()) === 0;
      });
    }

    parseRangeProduct(range, product) {
      var idx = this.optionIndexes(product);
      var mats = {};
      var self = this;
      (product.variants || []).forEach(function (v) {
        if (self.hiddenSku(v)) return;
        var opts = [v.option1, v.option2, v.option3];
        var matVal = idx.mat >= 0 ? opts[idx.mat] : null;
        var tratVal = idx.trat >= 0 ? opts[idx.trat] : v.title;
        var matKey = matOf(matVal) || matOf(v.title) || "1.56";
        if (!mats[matKey]) {
          mats[matKey] = {
            key: matKey,
            label: MATS[matKey] || String(matVal || "Resina"),
            tier: (range.tiers && range.tiers[matKey]) || "",
            brands: [],
          };
        }
        var name = String(tratVal || v.title || "").trim();
        mats[matKey].brands.push({
          id: v.id,
          name: name,
          fab: fabOf(name),
          treat: treatOf(name),
          price: v.price,
          available: v.available !== false,
          image: v.featured_image && v.featured_image.src ? v.featured_image.src : null,
        });
      });
      // Nome do tier quando o mapa não define: pela ordem do índice (mais grosso → mais fino).
      var keys = Object.keys(mats).sort(function (a, b) {
        return MAT_ORDER.indexOf(a) - MAT_ORDER.indexOf(b);
      });
      keys.forEach(function (k, i) {
        if (!mats[k].tier) mats[k].tier = TIER_NAMES[Math.min(i, TIER_NAMES.length - 1)];
      });
      return { product: product, mats: mats, matKeys: keys };
    }

    async loadCatalog() {
      if (this.catalog.loaded || this.catalog.loading) return;
      this.catalog.loading = true;
      var self = this;
      var jobs = [];
      (this.map.ranges || []).forEach(function (r) {
        if (!r.handle) return;
        jobs.push(
          self.resolveProduct(r.handle).then(function (p) {
            self.catalog.ranges[r.id] = p ? self.parseRangeProduct(r, p) : null;
          })
        );
      });
      (this.map.descanso || []).forEach(function (d) {
        if (!d.handle) return;
        jobs.push(
          self.resolveProduct(d.handle).then(function (p) {
            var variant = null;
            if (p && p.variants) {
              variant =
                (d.variantId &&
                  p.variants.find(function (v) {
                    return String(v.id) === String(d.variantId);
                  })) ||
                p.variants.find(function (v) {
                  return v.available !== false;
                }) ||
                p.variants[0];
            }
            self.catalog.descanso[d.id] = variant ? { product: p, variant: variant, solar: d.solar ? self.parseSolarProduct(p) : null } : null;
          })
        );
      });
      var solar = this.map.solar || {};
      if (solar.handle) {
        jobs.push(
          self.resolveProduct(solar.handle).then(function (p) {
            self.catalog.solar = p ? self.parseRangeProduct({ tiers: {} }, p) : null;
          })
        );
      }
      try {
        await Promise.all(jobs);
      } finally {
        this.catalog.loading = false;
        this.catalog.loaded = true;
        this.render();
      }
    }

    /* Solar sem grau: opção "Cor Total / Cor Degrade" + opção "Cor" vêm das variantes do produto. */
    parseSolarProduct(product) {
      var names = (product.options || []).map(function (o) {
        return String(typeof o === "string" ? o : (o && o.name) || "").toLowerCase();
      });
      var corIdx = names.findIndex(function (n) { return /^cor$|cor da lente|cores/.test(n); });
      if (corIdx < 0) return null;
      var tipoIdx = names.findIndex(function (n, i) { return i !== corIdx; });
      var tipos = [], cores = [];
      var self = this;
      (product.variants || []).forEach(function (v) {
        if (self.hiddenSku(v)) return;
        var o = [v.option1, v.option2, v.option3];
        var tipo = tipoIdx >= 0 ? o[tipoIdx] : "";
        var cor = o[corIdx];
        if (tipo && tipos.indexOf(tipo) < 0) tipos.push(tipo);
        if (cor && cores.indexOf(cor) < 0) cores.push(cor);
      });
      return { tipoIdx: tipoIdx, corIdx: corIdx, tipos: tipos, cores: cores, variants: product.variants || [] };
    }

    solarVariant(d, tipo, cor) {
      var c = this.catalog.descanso[d.id];
      if (!c || !c.solar) return c && c.variant;
      var so = c.solar;
      var self = this;
      var want = cor;
      if (cor === "custom") {
        // "Personalizar": cobra como a cor base (igual à foto); a cor real vai na propriedade e o atendimento confirma.
        want = so.cores.find(function (n) { return /original|foto|igual/i.test(n); }) || so.cores[0];
      }
      return (
        so.variants.find(function (v) {
          if (self.hiddenSku(v)) return false;
          var o = [v.option1, v.option2, v.option3];
          return (so.tipoIdx < 0 || o[so.tipoIdx] === tipo) && o[so.corIdx] === want;
        }) || null
      );
    }

    /* ───────────── dados derivados ───────────── */

    rangeDef(id) {
      if (id === "solar") return this.map.solar;
      return (this.map.ranges || []).find(function (r) {
        return r.id === id;
      });
    }

    rangeBlocked(r) {
      return Number(r.min || 0) > this.maxGrau;
    }

    /* Materiais disponíveis para a faixa: [{ key, label, tier, price, brands }]. Armação "so policarbonato": só poli. */
    matsFor(rangeId) {
      var r = this.rangeDef(rangeId);
      if (!r) return [];
      var list;
      if (this.state.category === "solar") {
        // Solar com grau: preço = variante do material no produto do mapa (map.solar.handle).
        // Óculos de sol: todas as espessuras de map.solar.tiers. Armação comum: só as da faixa (range.solar).
        var solar = this.catalog.solar;
        if (!solar) return [];
        var tiers = (this.map.solar && this.map.solar.tiers) || {};
        var keys = this.solarFrame ? Object.keys(tiers) : r.solar || [];
        list = keys
          .map(function (k) {
            if (!solar.mats[k]) return null;
            var v = solar.mats[k].brands.find(function (b) {
              return b.available;
            });
            if (!v) return null;
            return { key: k, label: MATS[k] || k, tier: tiers[k] || k, price: v.price, variantId: v.id, brands: [], exact: true };
          })
          .filter(Boolean);
      } else {
        var data = this.catalog.ranges[rangeId];
        if (!data) return [];
        list = data.matKeys
          .map(function (k) {
            var m = data.mats[k];
            var avail = m.brands.filter(function (b) {
              return b.available;
            });
            if (!avail.length) return null;
            var min = Math.min.apply(
              null,
              avail.map(function (b) {
                return b.price;
              })
            );
            return { key: k, label: m.label, tier: m.tier, price: min, brands: m.brands };
          })
          .filter(Boolean);
      }
      if (this.onlyPoli) {
        list = list.filter(function (m) {
          return m.key === "poli";
        });
      }
      return list;
    }

    currentMat() {
      var self = this;
      return this.matsFor(this.state.range).find(function (m) {
        return m.key === self.state.mat;
      });
    }

    /* Tratamentos para o material atual: [{ key, def, from, brands }] */
    tratsFor() {
      var m = this.currentMat();
      if (!m) return [];
      return TREAT_ORDER.map(function (t) {
        var brands = m.brands.filter(function (b) {
          return b.treat === t;
        });
        var avail = brands.filter(function (b) {
          return b.available;
        });
        if (!avail.length) return null;
        var from = Math.min.apply(
          null,
          avail.map(function (b) {
            return b.price;
          })
        );
        return { key: t, def: TREATS[t], from: from, brands: brands };
      })
        .filter(Boolean)
        .sort(function (a, b) {
          return a.from - b.from;
        });
    }

    currentBrand() {
      var self = this;
      var m = this.currentMat();
      if (!m) return null;
      return (
        m.brands.find(function (b) {
          return String(b.id) === String(self.state.opt);
        }) || null
      );
    }

    descDef(id) {
      return (this.map.descanso || []).find(function (d) {
        return d.id === id;
      });
    }

    descPrice(d) {
      var c = this.catalog.descanso[d.id];
      if (c && c.solar && this.state.cor) {
        var sv = this.solarVariant(d, this.state.corTipo, this.state.cor);
        if (sv) return sv.price;
      }
      return c && c.variant ? c.variant.price : d.price || 0;
    }

    descSellable(d) {
      // Lentes sem grau são resina 1.56: armação "so policarbonato" faz pelo WhatsApp.
      if (this.onlyPoli) return false;
      var c = this.catalog.descanso[d.id];
      return !!(c && c.variant && c.variant.available !== false);
    }

    stepsFor() {
      var s = this.state;
      if (s.category === "grau") return ["categoria", "grau", "espessura", "tratamento", "receita", "revisao"];
      if (s.category === "descanso") {
        var d = this.descDef(s.desc);
        return d && d.solar ? ["categoria", "descanso", "cor", "revisao"] : ["categoria", "descanso", "revisao"];
      }
      if (s.category === "solar") {
        return this.solarFrame ? ["categoria", "espessura", "receita", "revisao"] : ["categoria", "grau", "espessura", "cor", "receita", "revisao"];
      }
      if (s.category === "armacao") return ["categoria"];
      return ["categoria"];
    }

    lensPrice() {
      var s = this.state;
      if (s.category === "grau") {
        var b = this.currentBrand();
        return b ? b.price : 0;
      }
      if (s.category === "descanso") {
        var d = this.descDef(s.desc);
        return d ? this.descPrice(d) : 0;
      }
      if (s.category === "solar") {
        var m = this.currentMat();
        return m ? m.price : 0;
      }
      return 0;
    }

    lensPrazo() {
      var s = this.state;
      if (s.category === "descanso") {
        var d = this.descDef(s.desc);
        return (d && d.prazo) || "3 a 5 dias úteis";
      }
      if (s.category === "solar") return (this.map.solar && this.map.solar.prazo) || "5 a 7 dias úteis";
      var r = this.rangeDef(s.range);
      return (r && r.prazo) || "5 a 7 dias úteis";
    }

    lensName() {
      var s = this.state;
      var r = this.rangeDef(s.range);
      var m = this.currentMat();
      if (s.category === "grau") {
        var b = this.currentBrand();
        return "Lente " + (m ? m.tier : "") + (b ? " · " + b.name : "");
      }
      if (s.category === "descanso") {
        var d = this.descDef(s.desc);
        return d ? d.name : "Lente de descanso";
      }
      if (s.category === "solar") return "Lente solar " + (m ? m.tier : "");
      return "";
    }

    /* Nome da marca no seletor: a linha própria (variantes "Simples", "Blue Light"…) aparece como "Lollamundi";
       as outras com a grafia corrigida ("kodak Blue" → "Kodak Blue"). */
    brandName(b) {
      if (!b) return "";
      var n = String(b.name || "").trim();
      if (b.fab === "Lollamundi" && TREATS[b.treat] && n.toLowerCase() === TREATS[b.treat].name.toLowerCase()) return "Lollamundi";
      return n.replace(/(^|\s)([a-zà-ú])/g, function (all, sp, ch) {
        return sp + ch.toUpperCase();
      });
    }

    /* Diferencial da marca (map.marcas, pelo nome da variante); sem texto, o fabricante. */
    brandTag(b) {
      var key = String((b && b.name) || "").trim().toLowerCase();
      var marcas = this.map.marcas || {};
      if (marcas[key]) return marcas[key];
      return b && b.fab !== "Lollamundi" ? b.fab : "";
    }

    /* "Simples · Lollamundi", "Blue Light · Kodak Blue". */
    tratLabel(b) {
      if (!b) return "";
      return TREATS[b.treat].name + " · " + this.brandName(b);
    }

    corName() {
      var s = this.state;
      if (!s.cor) return "";
      if (s.cor === "foto" || /original|igual/i.test(s.cor)) return "Igual à foto do produto";
      return s.cor;
    }

    /* Resumo das lentes na revisão: "Grau leve · Padrão · Simples". */
    lensSummary() {
      var s = this.state;
      var r = this.rangeDef(s.range);
      var m = this.currentMat();
      var parts = [];
      if (s.category === "descanso") {
        var d = this.descDef(s.desc);
        return d ? d.short || d.name : "";
      }
      if (s.category === "solar") parts.push("Solar com grau");
      if (r && r.name) parts.push(r.name);
      if (m) parts.push(m.tier);
      var b = this.currentBrand();
      if (b) parts.push(TREATS[b.treat].name);
      return parts.join(" · ");
    }

    // Oferta da revisão: produto das configurações do tema (ou metafield da armação) > kit do mapa.
    kitInfo() {
      var up = this.upsell || {};
      if (up.enabled === false) return { title: "", price: 0, compareAt: 0, image: null, subtitle: "", handle: "", variantId: "" };
      var kit = up.variantId ? up : this.map.kit || {};
      return {
        title: kit.title || "Kit de limpeza",
        price: kit.price || 0,
        compareAt: kit.compareAt || 0,
        image: kit.image || null,
        subtitle: up.subtitle || kit.subtitle || "",
        handle: kit.handle || "",
        variantId: kit.variantId || "",
      };
    }

    waLink(text) {
      return "https://wa.me/" + this.whatsapp + "?text=" + encodeURIComponent(text);
    }

    /* ───────────── ações ───────────── */

    pick(action, value) {
      var s = this.state;
      this.clearError();
      switch (action) {
        case "categoria":
          if (s.category !== value) {
            Object.assign(s, this.defaultState(), { category: value, addKit: s.addKit, step: s.step });
            // Solar com grau no óculos de sol não escolhe faixa nem cor: a lente sai igual à foto do produto.
            if (value === "solar" && this.solarFrame) {
              s.range = this.solarRangeId();
              s.cor = "foto";
            }
          }
          break;
        case "range":
          if (s.range !== value) {
            s.range = value;
            s.mat = "";
            s.trat = "";
            s.opt = "";
          }
          break;
        case "mat":
          if (s.mat !== value) {
            s.mat = value;
            s.trat = "";
            s.opt = "";
          }
          break;
        case "trat":
          s.trat = s.trat === value ? "" : value;
          var b = this.currentBrand();
          if (b && b.treat !== s.trat) s.opt = "";
          break;
        case "opt":
          s.opt = value;
          break;
        case "desc":
          if (s.desc !== value) {
            s.desc = value;
            s.cor = "";
          }
          break;
        case "corTipo":
          s.corTipo = value;
          break;
        case "cor":
          s.cor = value;
          break;
        case "receita":
          s.rxMethod = value;
          if (value !== "upload") s.rxFile = null;
          break;
        case "kit":
          s.addKit = !s.addKit;
          break;
        case "goto":
          // "alterar" da revisão: volta direto para a etapa.
          if (this.stepsFor().indexOf(value) < 0) return;
          s.step = value;
          this.render(true);
          return;
        case "modal":
          this.openModal(value);
          return;
        case "modalClose":
          this.closeModal();
          return;
        case "finderPick":
          this.closeModal();
          if (s.range !== value) {
            s.range = value;
            s.mat = "";
            s.trat = "";
            s.opt = "";
          }
          break;
        default:
          return;
      }
      this.render();
    }

    /* ───────────── janelas da faixa ───────────── */

    openModal(name) {
      this.closeModal();
      var el = this.$('[data-gc-modal="' + name + '"]');
      if (!el) return;
      el.hidden = false;
      if (name === "faixa") this.renderFinder();
      var first = el.querySelector("input") || el.querySelector(".zl__modal-x");
      if (first) first.focus();
    }

    modalOpen() {
      return Array.prototype.some.call(this.$all("[data-gc-modal]"), function (el) {
        return !el.hidden;
      });
    }

    closeModal() {
      this.$all("[data-gc-modal]").forEach(function (el) {
        el.hidden = true;
      });
    }

    /* "Descubra sua faixa": maior esférico e maior cilíndrico (sinal não importa) → faixa do mapa. */
    finderRange() {
      function num(v) {
        var t = String(v || "").replace(",", ".").replace(/[^0-9.]/g, "");
        if (!t) return null;
        var n = parseFloat(t);
        return isNaN(n) ? null : Math.abs(n);
      }
      var esf = num(this.state.finder.esf);
      var cil = num(this.state.finder.cil);
      if (esf === null && cil === null) return null;
      esf = esf || 0;
      cil = cil || 0;
      if (esf === 0 && cil === 0) return { zero: true };
      if (esf > 12 || cil > 6) return { wa: true };
      if (cil <= 2) return { id: esf <= 3.5 ? "r1" : esf <= 5.75 ? "r2" : "r3" };
      if (cil <= 4) return esf <= 8 ? { id: "r4" } : { wa: true };
      return { id: "r5" };
    }

    renderFinder() {
      var out = this.$("[data-gc-finder-result]");
      if (!out) return;
      var res = this.finderRange();
      var html = "";
      if (!res) html = "";
      else if (res.zero) html = '<p class="zl__finder-msg">Sem grau nos dois campos? Volte e escolha <strong>Lentes de descanso (sem grau)</strong>.</p>';
      else if (res.wa) html = '<p class="zl__finder-msg">Esse grau a gente monta pelo atendimento. <a href="' + this.waLink("Oi! Quero lentes para o meu grau (esférico " + this.state.finder.esf + ", cilíndrico " + (this.state.finder.cil || "0") + ").") + '" target="_blank" rel="noopener">Fale com a gente no WhatsApp</a>.</p>';
      else {
        var r = this.rangeDef(res.id);
        var noSolar = this.state.category === "solar" && !(r.solar && r.solar.length);
        if (this.rangeBlocked(r)) {
          html = '<p class="zl__finder-msg">Sua faixa é <strong>' + esc(r.name) + "</strong>, mas esta armação aceita até " + fmtGrau(this.maxGrau) + ' graus. <a href="' + this.waLink("Oi! Meu grau é " + r.name + ". Qual armação vocês indicam?") + '" target="_blank" rel="noopener">Fale com a gente</a> para escolher outra armação.</p>';
        } else if (noSolar) {
          html = '<p class="zl__finder-msg">Sua faixa é <strong>' + esc(r.name) + "</strong>. Nessa faixa a lente solar com grau não é feita.</p>";
        } else {
          html =
            '<div class="zl__finder-hit"><span>Sua faixa</span><strong>' + esc(r.name) + "</strong><small>" + esc(r.sub || "") + "</small></div>" +
            '<button type="button" class="zl__foot-go zl__finder-go" data-action="finderPick" data-value="' + esc(r.id) + '">Escolher ' + esc(r.name) + "</button>";
        }
      }
      out.innerHTML = html;
    }

    canAdvance() {
      var s = this.state;
      switch (s.step) {
        case "categoria":
          return !!s.category;
        case "grau": {
          var r = this.rangeDef(s.range);
          return !!r && !this.rangeBlocked(r) && this.matsFor(s.range).length > 0;
        }
        case "espessura":
          return !!this.currentMat();
        case "tratamento":
          return !!this.currentBrand();
        case "descanso": {
          var d = this.descDef(s.desc);
          return !!d && this.descSellable(d);
        }
        case "cor": {
          if (s.category === "descanso") {
            var dd = this.descDef(s.desc);
            var cc = dd && this.catalog.descanso[dd.id];
            if (cc && cc.solar) return !!s.cor && !!this.solarVariant(dd, s.corTipo, s.cor);
          }
          return !!s.cor;
        }
        case "receita":
          return !!s.rxMethod && (s.rxMethod !== "upload" || !!s.rxFile);
        case "revisao":
          return true;
      }
      return false;
    }

    next() {
      var s = this.state;
      this.clearError();
      if (!this.canAdvance()) {
        var msg = {
          categoria: "Escolha como você vai usar os óculos.",
          grau: "Escolha a faixa do seu grau.",
          espessura: "Escolha a espessura da lente.",
          tratamento: "Escolha o tratamento e a marca.",
          descanso: "Escolha a proteção da lente.",
          cor: "Escolha a cor da lente.",
          receita: s.rxMethod === "upload" ? "Anexe a foto ou o PDF da receita." : "Escolha como enviar a receita.",
        }[s.step];
        this.showError(msg || "Complete esta etapa para continuar.");
        return;
      }
      // Revisão: "Finalizar compra" vai para a página do carrinho. Só a armação: direto para o carrinho lateral.
      if (s.category === "armacao") {
        this.submit("continuar");
        return;
      }
      if (s.step === "revisao") {
        this.submit("carrinho");
        return;
      }
      var steps = this.stepsFor();
      var i = steps.indexOf(s.step);
      if (i < steps.length - 1) {
        s.step = steps[i + 1];
        this.render(true);
      }
    }

    go(delta) {
      var steps = this.stepsFor();
      var i = steps.indexOf(this.state.step);
      this.clearError();
      if (i + delta < 0) {
        this.close();
        return;
      }
      this.state.step = steps[Math.min(steps.length - 1, i + delta)];
      this.render(true);
    }

    /* ───────────── render ───────────── */

    render(scrollTop) {
      if (!this.dialog) return;
      var s = this.state;
      var steps = this.stepsFor();
      if (steps.indexOf(s.step) < 0) s.step = "categoria";

      this.$all("[data-step]").forEach(function (el) {
        el.style.display = el.getAttribute("data-step") === s.step ? "flex" : "none";
      });

      this.renderProgress();
      this.renderHeader();
      switch (s.step) {
        case "categoria":
          this.renderCategoria();
          break;
        case "grau":
          this.renderGrau();
          break;
        case "espessura":
          this.renderEspessura();
          break;
        case "tratamento":
          this.renderTratamento();
          break;
        case "descanso":
          this.renderDescanso();
          break;
        case "cor":
          this.renderCor();
          break;
        case "receita":
          this.renderReceita();
          break;
        case "revisao":
          this.renderRevisao();
          break;
      }
      this.renderFooter();

      if (scrollTop) {
        var scroll = this.$("[data-gc-scroll]");
        if (scroll) scroll.scrollTop = 0;
      }
      this.dispatchEvent(new CustomEvent("glasses:step", { bubbles: true, detail: { step: s.step, state: s } }));
    }

    renderProgress() {
      var steps = this.stepsFor();
      var idx = Math.max(0, steps.indexOf(this.state.step));
      var total = steps.length;
      var label = this.$("[data-gc-prog-label]");
      var fill = this.$("[data-gc-prog-fill]");
      if (label) {
        label.innerHTML = this.state.step === "revisao" ? "Quase lá!" : "Etapa <strong>" + (idx + 1) + "</strong> de " + total;
      }
      if (fill) fill.style.width = Math.round(((idx + 1) / Math.max(total, 1)) * 100) + "%";
    }

    renderHeader() {
      var el = this.$("[data-gc-header-price]");
      if (!el) return;
      var variant = this.frameVariant();
      var frame = variant && variant.price != null ? variant.price : this.product.price || 0;
      var lens = this.lensPrice();
      el.textContent = lens ? "Armação " + money(frame) + " + lentes " + money(lens) : "Armação " + money(frame);
    }

    renderFooter() {
      var s = this.state;
      var steps = this.stepsFor();
      var idx = steps.indexOf(s.step);
      var total = steps.length;
      var next = this.$("[data-gc-next]");
      if (next) {
        var label = s.category === "armacao" ? "Adicionar ao carrinho" : total === 1 ? "Continuar" : idx === total - 1 ? "Finalizar compra" : idx === total - 2 ? "Revisar pedido" : "Continuar";
        next.textContent = label;
        next.disabled = !this.canAdvance();
      }
      var viewCart = this.$("[data-gc-view-cart]");
      if (viewCart) {
        viewCart.hidden = s.step !== "revisao" || s.category === "armacao";
        viewCart.disabled = !!this._submitting;
      }
    }

    renderCategoria() {
      var s = this.state;
      this.$all('[data-action="categoria"]').forEach(function (el) {
        el.classList.toggle("is-selected", el.getAttribute("data-value") === s.category);
      });
      var solarBtn = this.$("[data-gc-solar-category]");
      if (!solarBtn) return;
      // "Solar com grau" aparece na armação comum (escolhe faixa e cor) e no óculos de sol (igual à foto).
      // Óculos de sol vendem só "Solar com grau" ou "Só a armação": somem "com grau" e "descanso".
      var enabled = (this.map.solar || {}).enabled !== false;
      solarBtn.style.display = enabled ? "" : "none";
      if (!enabled && s.category === "solar") s.category = "";
      var desc = solarBtn.querySelector(".zl__item-body span");
      if (desc) desc.textContent = this.solarFrame ? "Lente escura com o seu grau, na mesma cor da foto" : "Lente escura com o seu grau, na cor que você escolher";
      var solarFrame = this.solarFrame;
      this.$all('[data-action="categoria"][data-value="grau"], [data-action="categoria"][data-value="descanso"]').forEach(function (el) {
        el.style.display = solarFrame ? "none" : "";
        if (solarFrame && el.getAttribute("data-value") === s.category) s.category = "";
      });
    }

    /* Solar com grau não pergunta a faixa: o próprio map.solar faz o papel dela (tiers = espessuras que a ótica faz
       em solar, notes = linhas de grau de cada uma, prazo). Sem tiers, usa a última faixa do mapa. */
    solarRangeId() {
      var ranges = this.map.ranges || [];
      if (this.map.solar && this.map.solar.tiers) return "solar";
      return ranges.length ? ranges[ranges.length - 1].id : "";
    }

    renderGrau() {
      var self = this;
      var s = this.state;
      var wrap = this.$("[data-gc-ranges]");
      if (!wrap) return;
      this.loadCatalog();
      var note = this.$("[data-gc-grau-note]");
      if (note) {
        note.hidden = !this.onlyPoli;
        note.textContent = this.onlyPoli ? "Esta armação só pode ser feita com lente de policarbonato." : "";
      }
      var ranges = this.map.ranges || [];
      var groups = this.map.groups || {};
      var order = [];
      ranges.forEach(function (r) {
        if (order.indexOf(r.group) < 0) order.push(r.group);
      });
      var card = function (r) {
        var blocked = self.rangeBlocked(r);
        var noSolar = s.category === "solar" && !(r.solar && r.solar.length);
        var loading = !self.catalog.loaded && !!r.handle;
        var mats = self.catalog.loaded && !blocked && !noSolar ? self.matsFor(r.id) : [];
        var sellable = mats.length > 0;
        var on = s.range === r.id;
        var line = blocked ? "Acima do limite desta armação (" + fmtGrau(self.maxGrau) + ")" : noSolar ? "Lente solar com grau não é feita nesta faixa" : r.sub || "";
        var side;
        if (blocked) side = LOCK_SVG;
        else if (noSolar) side = "";
        else if (loading) side = "…";
        else if (sellable) {
          var from = Math.min.apply(
            null,
            mats.map(function (m) {
              return m.price;
            })
          );
          side = "<small>a partir de</small><b>" + money(from) + "</b>";
        } else side = "<small>sob</small><b>consulta</b>";
        var off = blocked || noSolar;
        var waOnly = !off && !loading && !sellable;
        var cls = "zl__row" + (on ? " is-selected" : "") + (off ? " is-off" : "") + (waOnly ? " zl__row--wa" : "");
        var inner =
          '<span class="zl__radio" aria-hidden="true"></span>' +
          '<span class="zl__row-txt"><strong>' + esc(r.name || r.label) + "</strong>" + (line ? "<span>" + esc(line) + "</span>" : "") + "</span>" +
          '<span class="zl__row-price">' + (waOnly ? WA_SVG : side) + "</span>";
        if (waOnly) {
          var txt = "Oi! Quero lentes " + (s.category === "solar" ? "solares " : "") + "na faixa " + r.label + " para " + (self.product.title || "meus óculos") + ".";
          return '<a class="' + cls + '" href="' + self.waLink(txt) + '" target="_blank" rel="noopener">' + inner + "</a>";
        }
        return '<button type="button" class="' + cls + '" data-action="range" data-value="' + esc(r.id) + '"' + (off ? " disabled" : "") + ">" + inner + "</button>";
      };
      wrap.innerHTML = order
        .map(function (g) {
          return (
            (groups[g] ? '<p class="zl__group">' + esc(groups[g]) + "</p>" : "") +
            ranges
              .filter(function (r) {
                return r.group === g;
              })
              .map(card)
              .join("")
          );
        })
        .join("");
    }

    renderEspessura() {
      var s = this.state;
      var wrap = this.$("[data-gc-mats]");
      if (!wrap) return;
      if (s.category === "solar" && this.solarFrame) s.range = this.solarRangeId();
      var sub = this.$("[data-gc-esp-sub]");
      if (sub) sub.textContent = this.onlyPoli ? "Esta armação só pode ser feita com lente de policarbonato." : "Quanto mais fina, mais leve e discreta fica na borda da armação.";
      var r = this.rangeDef(s.range);
      var mats = this.matsFor(s.range);
      var isSolar = s.category === "solar";
      // Solar com grau no óculos de sol abre direto aqui (sem a etapa da faixa): o catálogo pode ainda estar carregando.
      if (!mats.length) {
        this.loadCatalog();
        wrap.innerHTML = this.catalog.loaded
          ? '<a class="zl__row zl__row--wa" href="' + this.waLink("Oi! Quero lentes " + (isSolar ? "solares com grau " : "") + "para " + (this.product.title || "meus óculos") + ".") + '" target="_blank" rel="noopener"><span class="zl__row-txt"><strong>Fale com a gente no WhatsApp</strong><span>Montamos sua lente pelo atendimento</span></span><span class="zl__row-price">' + WA_SVG + "</span></a>"
          : '<p class="zl__subtitle">Carregando as opções…</p>';
        return;
      }
      var solarNotes = (isSolar && this.map.solar && this.map.solar.notes) || {};
      var base = mats[0];
      var baseT = THICK[base.key] || 14;
      wrap.innerHTML =
        mats
          .map(function (m, i) {
            var on = s.mat === m.key;
            var t = THICK[m.key] || 10;
            var pct = Math.round(((1 - t / baseT) * 100) / 5) * 5;
            var badge = i > 0 && pct > 0 ? '<span class="zl__badge">Cerca de ' + pct + "% mais fina</span>" : "";
            // Frase: a do mapa (solar ou faixa com "notes", ex.: astigmatismo) ou, sem ela, pela POSIÇÃO na faixa
            // (o mesmo material é fino num grau e não em outro). Lista no mapa = uma linha por item.
            var note = isSolar && solarNotes[m.key] ? solarNotes[m.key] : r && r.notes && r.notes[m.key] ? r.notes[m.key] : i === 0 ? PROFILE_NOTE_FIRST : i === mats.length - 1 ? PROFILE_NOTE_LAST : PROFILE_NOTES[Math.min(i - 1, PROFILE_NOTES.length - 1)];
            return (
              '<button type="button" class="zl__row zl__row--lens' + (on ? " is-selected" : "") + '" data-action="mat" data-value="' + esc(m.key) + '">' +
              '<span class="zl__radio" aria-hidden="true"></span>' +
              '<span class="zl__lens"><svg viewBox="0 0 60 90" width="26" height="40" aria-hidden="true"><path d="' + lensProfilePath(i) + '" fill="' + (on ? "#cfe3f5" : "#e5e7eb") + '" stroke="' + (on ? "#111" : "#9ca3af") + '" stroke-width="2.5" stroke-linejoin="round"/></svg></span>' +
              '<span class="zl__row-txt"><strong>' + esc(m.tier) + badge + "</strong><span>" + esc(m.label) + "</span>" +
              [].concat(note).map(function (n) {
                return '<em class="zl__row-note">' + esc(n) + "</em>";
              }).join("") +
              "</span>" +
              '<span class="zl__row-price">' + (m.exact ? "" : "<small>a partir de</small>") + "<b>" + money(m.price) + "</b></span>" +
              "</button>"
            );
          })
          .join("") +
        '<p class="zl__prazo-line">Produção: ' + esc(this.lensPrazo()) + (mats.length > 1 ? " em todas as opções" : "") + ".</p>";
    }

    /* Cartão com animação ao lado (tratamento com grau e lentes sem grau): nome, etiquetas e preço. */
    gifCard(key, name, priceHtml, best) {
      var def = TREATS[key] || { tags: [] };
      var src = this.gifs[key];
      return (
        (best ? '<span class="zl__item-ribbon">Mais vendido</span>' : "") +
        '<span class="zl__gif">' + (src ? '<img src="' + esc(src) + '" width="240" height="240" loading="lazy" alt="">' : "") + "</span>" +
        '<span class="zl__gif-body"><strong>' + esc(name) + "</strong>" +
        (def.badge ? '<span class="zl__tags"><span class="zl__tag zl__tag--blue">' + esc(def.badge) + "</span></span>" : "") +
        '<ul class="zl__checks">' +
        def.tags.map(function (t) {
          return "<li>" + esc(t) + "</li>";
        }).join("") +
        "</ul>" + priceHtml + "</span>"
      );
    }

    renderTratamento() {
      var self = this;
      var s = this.state;
      var wrap = this.$("[data-gc-trats]");
      if (!wrap) return;
      var m = this.currentMat();
      var sub = this.$("[data-gc-trat-sub]");
      if (sub && m) sub.textContent = "Toque no tratamento para ver as marcas para a lente " + m.tier.toLowerCase() + " (" + m.label + ").";
      wrap.innerHTML = this.tratsFor()
        .map(function (t) {
          var open = s.trat === t.key;
          // Sem preço no cartão: os valores aparecem nas marcas, ao abrir.
          var card =
            '<button type="button" class="zl__card zl__card--gif' + (open ? " is-selected is-open" : "") + '" data-action="trat" data-value="' + t.key + '"' + (open ? ' aria-expanded="true"' : ' aria-expanded="false"') + ">" +
            self.gifCard(t.key, t.def.name, "", t.def.best) +
            "</button>";
          var acc = "";
          if (open) {
            var brands = t.brands.slice().sort(function (a, b) {
              return a.price - b.price;
            });
            acc =
              '<div class="zl__acc"><span class="zl__acc-label">Escolha a marca · ' + esc(t.def.name) + "</span>" +
              brands
                .map(function (b) {
                  var on = String(s.opt) === String(b.id);
                  var tag = self.brandTag(b);
                  return (
                    '<button type="button" class="zl__brand' + (on ? " is-selected" : "") + (b.available ? "" : " is-off") + '" data-action="opt" data-value="' + b.id + '"' + (b.available ? "" : " disabled") + ">" +
                    '<span class="zl__radio" aria-hidden="true"></span>' +
                    '<span class="zl__brand-txt"><span class="zl__brand-n">' + esc(self.brandName(b)) + "</span>" + (tag ? '<span class="zl__brand-f">' + esc(tag) + "</span>" : "") + "</span>" +
                    '<span class="zl__brand-p">' + (b.available ? money(b.price) : "Esgotado") + "</span></button>"
                  );
                })
                .join("") +
              "</div>";
          }
          return '<div class="zl__trat">' + card + acc + "</div>";
        })
        .join("");
    }

    renderDescanso() {
      var self = this;
      var s = this.state;
      var wrap = this.$("[data-gc-descanso]");
      if (!wrap) return;
      this.loadCatalog();
      // Do mais barato para o mais caro; solar sem grau vai sempre por último; "Sob consulta" vai para o fim.
      var list = (this.map.descanso || []).map(function (d) {
        var loading = !self.catalog.loaded && !!d.handle;
        var waOnly = !loading && !self.descSellable(d);
        return { d: d, waOnly: waOnly, price: self.descPrice(d) };
      });
      list.sort(function (a, b) {
        return a.waOnly - b.waOnly || (!!a.d.solar - !!b.d.solar) || a.price - b.price;
      });
      wrap.innerHTML = list
        .map(function (x) {
          var d = x.d;
          var key = d.solar ? "sol" : treatOf(d.name);
          var name = d.solar ? TREATS.sol.name : TREATS[key].name;
          var priceHtml = x.waOnly
            ? '<span class="zl__gif-price">Sob consulta · fale no WhatsApp</span>'
            : '<span class="zl__gif-price">' + (d.compareAt && d.compareAt > x.price ? "<s>" + money(d.compareAt) + "</s> " : "") + "<b>" + money(x.price) + "</b></span>";
          var inner = self.gifCard(key, name, priceHtml, d.best);
          var cls = "zl__card zl__card--gif zl__card--solo" + (s.desc === d.id ? " is-selected" : "") + (x.waOnly ? " zl__card--wa" : "");
          if (x.waOnly) {
            return '<a class="' + cls + '" href="' + self.waLink("Oi! Quero " + d.name + " para " + (self.product.title || "meus óculos") + ".") + '" target="_blank" rel="noopener">' + inner + "</a>";
          }
          return '<button type="button" class="' + cls + '" data-action="desc" data-value="' + esc(d.id) + '">' + inner + "</button>";
        })
        .join("");
    }

    /* Cores da lente solar: as do produto "solar sem grau" (Cor Total/Degradê × cores), sem "igual à foto".
       Solar sem grau: cada cor é uma variante. Solar com grau (armação comum): a cor vai anotada no pedido. */
    solarColors() {
      var s = this.state;
      if (s.category === "descanso") {
        var dd = this.descDef(s.desc);
        var cc = dd && this.catalog.descanso[dd.id];
        return cc && cc.solar;
      }
      var solarDesc = (this.map.descanso || []).find(function (d) {
        return d.solar;
      });
      var c = solarDesc && this.catalog.descanso[solarDesc.id];
      return (c && c.solar) || { tipos: ["Cor Total", "Cor Degrade"], cores: ["Preto", "Marrom", "Verde"] };
    }

    renderCor() {
      var self = this;
      var s = this.state;
      var wrap = this.$("[data-gc-cores]");
      if (!wrap) return;
      var dd = s.category === "descanso" ? this.descDef(s.desc) : null;
      var so = this.solarColors() || { tipos: [], cores: [] };
      var seg = this.$("[data-gc-cor-tipo]");
      if (seg) {
        if (so.tipos.length) {
          seg.style.display = "";
          if (so.tipos.indexOf(s.corTipo) < 0) s.corTipo = so.tipos[0];
          seg.innerHTML = so.tipos
            .map(function (t) {
              return '<button type="button" class="zl__seg-btn' + (t === s.corTipo ? " is-on" : "") + '" data-action="corTipo" data-value="' + esc(t) + '">' + esc(t.replace(/^Cor /i, "")) + "</button>";
            })
            .join("");
        } else {
          seg.style.display = "none";
        }
      }
      var degrade = /degrad/i.test(s.corTipo || "");
      var cores = so.cores
        .filter(function (name) {
          return !/original|foto|igual/i.test(name);
        })
        .map(function (name) {
          return { id: name, name: name, hex: COLOR_HEX[name.toLowerCase()] || null, available: !dd || !!self.solarVariant(dd, s.corTipo, name) };
        });
      wrap.innerHTML = cores
        .map(function (c) {
          var on = s.cor === c.id;
          var sw = '<span class="zl__sw" style="background:' + (c.hex ? (degrade ? "linear-gradient(" + c.hex + ", #fff)" : c.hex) : "#e5e7eb") + '"></span>';
          return (
            '<button type="button" class="zl__item' + (on ? " is-selected" : "") + (c.available ? "" : " is-off") + '" data-action="cor" data-value="' + esc(c.id) + '"' + (c.available ? "" : " disabled") + ">" +
            sw +
            '<div class="zl__item-body"><strong>' + esc(c.name) + "</strong>" + (c.available ? "" : "<span>Indisponível</span>") + "</div>" +
            '<span class="zl__chevron">' + (on ? CHECK_SVG : CHEV_SVG) + "</span></button>"
          );
        })
        .join("");
    }

    renderReceita() {
      var s = this.state;
      this.$all("[data-gc-rx-opt]").forEach(function (el) {
        el.classList.toggle("is-selected", el.getAttribute("data-gc-rx-opt") === s.rxMethod);
      });
      var up = this.$("[data-gc-upload]");
      if (up) up.classList.toggle("has-file", !!s.rxFile);
      var name = this.$("#zlRxFileName");
      if (name) name.textContent = s.rxFile ? s.rxFile.name : "Tirar foto ou escolher arquivo";
      var prazo = this.$("[data-gc-rx-prazo]");
      if (prazo) prazo.textContent = this.lensPrazo();
    }

    renderRevisao() {
      var self = this;
      var s = this.state;
      var wrap = this.$("[data-gc-review]");
      if (!wrap) return;
      var steps = this.stepsFor();
      var variant = this.frameVariant();
      var frame = variant && variant.price != null ? variant.price : this.product.price || 0;
      var lp = this.lensPrice();
      var kit = this.kitInfo();
      var hasKit = !!(kit.variantId || kit.handle);
      var kitP = s.addKit && hasKit ? kit.price : 0;
      var r = this.rangeDef(s.range);
      var m = this.currentMat();
      var b = this.currentBrand();
      var d = this.descDef(s.desc);
      var alterar = function (step) {
        return steps.indexOf(step) >= 0 ? '<button type="button" class="zl__review-edit" data-action="goto" data-value="' + step + '">alterar</button>' : "";
      };
      // Armação: só o modelo (sem repetir "Armação") e a cor da variante.
      var frameName = String(this.product.title || "").replace(/^\s*arma[cç][aã]o\s*/i, "") + (variant && variant.title && variant.title !== "Default Title" ? " · " + variant.title : "");
      var grauTxt = "";
      if (s.category === "grau" && r) grauTxt = esc(r.label);
      else if (s.category === "solar") grauTxt = "Solar com grau" + (!this.solarFrame && r && r.label ? " · " + esc(r.label) : "");
      else if (s.category === "descanso") grauTxt = "Sem grau";
      var rows = [["Armação", "<strong>" + esc(frameName) + "</strong>", money(frame)]];
      rows.push(["Grau", grauTxt, alterar(steps.indexOf("grau") >= 0 ? "grau" : "categoria")]);
      if (m) rows.push(["Espessura", "<strong>" + esc(m.tier) + "</strong> · " + esc(m.label), alterar("espessura")]);
      if (b) rows.push(["Tratamento", "<strong>" + esc(TREATS[b.treat].name) + "</strong> · " + esc(this.brandName(b)), alterar("tratamento")]);
      if (d) rows.push(["Lente", "<strong>" + esc(d.name) + "</strong>", alterar("descanso")]);
      if (s.cor) rows.push(["Cor da lente", (s.corTipo && s.cor !== "foto" ? esc(s.corTipo.replace(/^Cor /i, "")) + " · " : "") + "<strong>" + esc(this.corName()) + "</strong>", alterar("cor")]);
      if (s.category !== "descanso") rows.push(["Receita", "<strong>" + (s.rxMethod === "upload" ? "Enviada agora" : "Depois pelo WhatsApp") + "</strong>", alterar("receita")]);
      rows.push(["Lentes", "<strong>" + esc(this.lensSummary()) + "</strong>", money(lp)]);
      rows.push(["Prazo de produção", "<strong>" + esc(this.lensPrazo()) + "</strong>" + (s.category !== "descanso" ? " após receber a receita" : ""), ""]);
      wrap.innerHTML = rows
        .map(function (row) {
          return '<div class="zl__review-row"><span class="zl__review-label">' + row[0] + '</span><span class="zl__review-value">' + row[1] + '</span><span class="zl__review-side">' + row[2] + "</span></div>";
        })
        .join("");

      var box = this.$("[data-gc-kitbox]");
      if (box) {
        box.style.display = hasKit ? "" : "none";
        box.classList.toggle("is-on", !!s.addKit);
      }
      this.loadKitImage();
      var btn = this.$("[data-gc-kit-btn]");
      if (btn) {
        btn.textContent = s.addKit ? "✓ Adicionado" : "+ Adicionar";
        btn.setAttribute("aria-pressed", s.addKit ? "true" : "false");
      }
      var total = this.$("[data-gc-total]");
      if (total) total.textContent = money(frame + lp + kitP);
    }

    /* Oferta vinda do mapa: id, preço e foto lidos do produto (o mapa só guarda o handle e um preço inicial). */
    loadKitImage() {
      if (!this._kitImgPending) return;
      this._kitImgPending = false;
      var self = this;
      var kit = this.kitInfo();
      this.resolveProduct(kit.handle).then(function (p) {
        self._kitResolved = true;
        var v =
          p &&
          p.variants &&
          (p.variants.find(function (x) {
            return x.available !== false;
          }) ||
            p.variants[0]);
        if (v && !(self.upsell || {}).variantId) {
          self.map.kit = Object.assign({}, self.map.kit, { variantId: v.id, price: v.price, compareAt: v.compare_at_price || 0 });
          self.hydrateKitCopy();
          if (self.state.step === "revisao") self.renderRevisao();
        }
        var img = self.$("[data-gc-kit-img]");
        var src = p && (p.featured_image || (p.images && p.images[0]));
        if (img && src) {
          src = (src.indexOf("//") === 0 ? "https:" : "") + src;
          img.src = src + (src.indexOf("?") < 0 ? "?" : "&") + "width=240";
          img.alt = kit.title;
          return;
        }
        var wrap = self.$("[data-gc-kit-img-wrap]");
        if (wrap) wrap.innerHTML = '<div class="zl__kit-thumb zl__kit-thumb--ph">' + esc(kit.title) + "</div>";
      });
    }

    hydrateKitCopy() {
      var kit = this.kitInfo();
      var img = this.$("[data-gc-kit-img]");
      var wrap = this.$("[data-gc-kit-img-wrap]");
      if (img) {
        if (kit.image) {
          img.src = kit.image;
          img.alt = kit.title;
        } else if (kit.handle && !this._kitResolved) {
          // Oferta vinda do mapa (sem produto escolhido nas configurações): foto e preço vêm do produto ao chegar na revisão.
          this._kitImgPending = true;
        } else if (wrap && !kit.handle) {
          wrap.innerHTML = '<div class="zl__kit-thumb zl__kit-thumb--ph">' + esc(kit.title) + "</div>";
        }
      }
      var title = this.$("[data-gc-kit-title]");
      if (title) title.textContent = "Adicionar " + kit.title + "?";
      var sub = this.$("[data-gc-kit-sub]");
      if (sub) sub.textContent = kit.subtitle;
      var price = this.$("[data-gc-kit-price]");
      var compare = this.$("[data-gc-kit-compare]");
      if (price) price.textContent = (kit.compareAt > kit.price ? "por " : "") + money(kit.price);
      if (compare) {
        compare.textContent = kit.compareAt > kit.price ? money(kit.compareAt) : "";
        compare.style.display = kit.compareAt > kit.price ? "" : "none";
      }
    }

    /* ───────────── erros ───────────── */

    showError(message) {
      var el = this.$("#zenoError");
      if (!el) return;
      el.textContent = message || "";
      el.style.display = message ? "" : "none";
      if (message) {
        var scroll = this.$("[data-gc-scroll]");
        if (scroll) scroll.scrollTop = scroll.scrollHeight;
      }
    }

    clearError() {
      this.showError("");
    }

    /* ───────────── abrir / fechar ───────────── */

    isOpen() {
      return !!(this.dialog && this.dialog.getAttribute("aria-hidden") === "false");
    }

    open() {
      if (!this.dialog) return;
      this._lastFocus = document.activeElement;
      if (this.dialog.parentElement !== document.body) {
        this._home = { parent: this.dialog.parentNode, next: this.dialog.nextSibling };
        document.body.appendChild(this.dialog);
      }
      this.dialog.hidden = false;
      this.dialog.removeAttribute("hidden");
      this.dialog.style.display = "flex";
      this.dialog.setAttribute("aria-hidden", "false");
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty("--zl-scrollbar-width", scrollbarWidth + "px");
      document.body.classList.add("zl-open", "glasses-customizer-open");
      this.loadCatalog();
      this.render(true);
      document.addEventListener("focus", this._focusHandler, true);
      var closeBtn = this.dialog.querySelector(".zl__btn-close");
      if (closeBtn) closeBtn.focus();
      this.dispatchEvent(new CustomEvent("glasses:open", { bubbles: true }));
    }

    /* Fechar pelo X ou Esc: se o cliente já escolheu algo, pergunta antes (Continuar escolhendo / Fechar).
       Na primeira tela sem escolha nenhuma, fecha direto. Fechamentos do próprio fluxo (após adicionar) usam close(). */
    requestClose() {
      var confirmEl = this.$("[data-gc-confirm]");
      if (!confirmEl || !this.state.category) {
        this.close();
        return;
      }
      confirmEl.hidden = false;
      var stay = confirmEl.querySelector("[data-gc-confirm-stay]");
      if (stay) stay.focus();
    }

    confirmOpen() {
      var confirmEl = this.$("[data-gc-confirm]");
      return !!confirmEl && !confirmEl.hidden;
    }

    hideConfirm(refocus) {
      var confirmEl = this.$("[data-gc-confirm]");
      if (!confirmEl || confirmEl.hidden) return;
      confirmEl.hidden = true;
      if (refocus) {
        var closeBtn = this.dialog.querySelector(".zl__btn-close");
        if (closeBtn) closeBtn.focus();
      }
    }

    close() {
      if (!this.isOpen()) return;
      this.hideConfirm(false);
      this.dialog.hidden = true;
      this.dialog.setAttribute("hidden", "");
      this.dialog.style.display = "none";
      this.dialog.setAttribute("aria-hidden", "true");
      document.body.classList.remove("zl-open", "glasses-customizer-open");
      document.removeEventListener("focus", this._focusHandler, true);
      if (this._home && this._home.parent) {
        this._home.parent.insertBefore(this.dialog, this._home.next);
        this._home = null;
      }
      if (this._lastFocus && typeof this._lastFocus.focus === "function") {
        this._lastFocus.focus();
      }
      this.dispatchEvent(new CustomEvent("glasses:close", { bubbles: true }));
    }

    onFocusTrap(e) {
      if (!this.isOpen() || !this.dialog) return;
      if (this.dialog.contains(e.target)) return;
      var list =
        theme.utilities && theme.utilities.getFocusableElements
          ? theme.utilities.getFocusableElements(this.dialog)
          : Array.from(this.dialog.querySelectorAll("button, [href], input, select, textarea"));
      if (list.length) list[0].focus();
    }

    /* ───────────── armação (PDP) ───────────── */

    frameVariant() {
      var id = this.frameVariantId();
      var variants = this.product.variants || [];
      return (
        variants.find(function (v) {
          return String(v.id) === String(id);
        }) ||
        variants[0] ||
        null
      );
    }

    frameVariantId() {
      var input = document.querySelector('form[data-product-id="' + this.product.id + '"] input[name="id"]');
      if (input && input.value) return input.value;
      var v = this.product.variants && this.product.variants[0];
      return v ? v.id : null;
    }

    frameQty() {
      var input = document.querySelector('form[data-product-id="' + this.product.id + '"] input[name="quantity"]');
      var q = input ? parseInt(input.value, 10) : 1;
      return q > 0 ? q : 1;
    }

    syncPreview() {
      var variant = this.frameVariant();
      var img = this.$("[data-gc-preview-img]");
      if (img && variant && variant.featuredImage && img.tagName === "IMG") img.src = variant.featuredImage;
      var title = this.$("[data-gc-preview-title]");
      if (title) title.textContent = this.product.title || "";
    }

    /* ───────────── carrinho ───────────── */

    lensVariantId() {
      var s = this.state;
      if (s.category === "grau") {
        var b = this.currentBrand();
        return b ? b.id : null;
      }
      if (s.category === "descanso") {
        var d = this.descDef(s.desc);
        var c = d && this.catalog.descanso[d.id];
        if (c && c.solar) {
          var sv = this.solarVariant(d, s.corTipo, s.cor);
          return sv ? sv.id : null;
        }
        return c && c.variant ? c.variant.id : null;
      }
      if (s.category === "solar") {
        var m = this.currentMat();
        return m && m.variantId ? m.variantId : null;
      }
      return null;
    }

    buildLensProperties() {
      var s = this.state;
      var r = this.rangeDef(s.range);
      var m = this.currentMat();
      var b = this.currentBrand();
      var d = this.descDef(s.desc);
      // Visível no carrinho só o que o título da lente não diz: espessura (sem material), tratamento, cor, receita e prazo.
      // Armação, uso e faixa ficam ocultos (prefixo _) para o pedido.
      var props = {
        _tipo: "lente",
        _armacao: this.product.title || "",
        _uso: { grau: "Com grau", descanso: "Sem grau", solar: "Solar com grau" }[s.category] || "",
      };
      if (r && r.label && (s.category === "grau" || (s.category === "solar" && !this.solarFrame))) props._faixa = r.label;
      if (m) {
        props.Espessura = m.tier;
        props._material = m.label;
      }
      if (b) props.Tratamento = this.tratLabel(b);
      if (d) props.Lente = d.name;
      if (s.cor) props["Cor da lente"] = (s.corTipo && s.cor !== "foto" ? s.corTipo.replace(/^Cor /i, "") + " · " : "") + this.corName();
      if (s.category !== "descanso") props["Envio receita"] = s.rxMethod === "upload" ? "Anexada no pedido" : "Via WhatsApp";
      props["Prazo de produção"] = this.lensPrazo();
      return props;
    }

    appendProperties(fd, props) {
      Object.keys(props).forEach(function (key) {
        if (props[key] != null && props[key] !== "") fd.append("properties[" + key + "]", props[key]);
      });
    }

    async submit(destino) {
      if (this._submitting) return;
      this.clearError();
      this._submitting = true;
      var loading = this.$("#zenoLoading");
      if (loading) loading.style.display = "flex";
      var nextBtn = this.$("[data-gc-next]");
      if (nextBtn) nextBtn.disabled = true;
      var viewCartBtn = this.$("[data-gc-view-cart]");
      if (viewCartBtn) viewCartBtn.disabled = true;
      try {
        var items = [];
        var s = this.state;
        var frameOnly = s.category === "armacao";
        var lensId = frameOnly ? null : this.lensVariantId();
        if (!frameOnly && !lensId) throw new Error("Essa opção de lente ainda não está disponível para compra on-line. Fale com a gente no WhatsApp.");

        // Armação + lente levam a mesma _grupo (oculta): o carrinho mostra as duas num card só,
        // com uma quantidade e um remover (snippets/cart-panel-group e cart-page-group).
        var qty = this.frameQty();
        var grupo = frameOnly ? "" : "G" + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
        var frameId = this.frameVariantId();
        if (!frameId) throw new Error("Selecione uma cor da armação.");
        items.push({
          payload: {
            id: Number(frameId),
            quantity: qty,
            // Só a armação: vai sozinha, com a lente de fábrica anotada na linha.
            properties: frameOnly ? { _tipo: "armacao_sem_lente", Lente: FRAME_ONLY_LENS } : { _tipo: "armacao", _grupo: grupo, _lentes: this.lensName() },
          },
        });

        var props = frameOnly ? null : this.buildLensProperties();
        if (props && grupo) props._grupo = grupo;
        if (frameOnly) {
          // sem item de lente
        } else if (s.rxMethod === "upload" && s.rxFile) {
          var fd = new FormData();
          fd.append("id", String(lensId));
          fd.append("quantity", String(qty));
          this.appendProperties(fd, props);
          fd.append("properties[Receita Anexada]", s.rxFile);
          items.push({ payload: fd });
        } else {
          items.push({ payload: { id: Number(lensId), quantity: qty, properties: props } });
        }

        if (s.addKit && !frameOnly) {
          var kit = this.kitInfo();
          var kitVariant = null;
          if (kit.variantId) kitVariant = { id: Number(kit.variantId) };
          else if (kit.handle) {
            var kitProduct = await this.resolveProduct(kit.handle);
            kitVariant = kitProduct && kitProduct.variants && kitProduct.variants[0];
          }
          if (kitVariant) items.push({ optional: true, payload: { id: kitVariant.id, quantity: 1, properties: { _tipo: "kit" } } });
        }

        if (!theme.cart || typeof theme.cart.addMany !== "function") {
          throw new Error("Carrinho indisponível. Recarregue a página.");
        }

        // "continuar" abre o carrinho lateral; "carrinho" e "checkout" saem da página, então não abrem a gaveta.
        var result = await theme.cart.addMany(items, { openDrawer: destino === "continuar" });
        var requiredFail = (result.errors || []).some(function (err) {
          return !err.optional;
        });
        if (requiredFail) {
          var first = result.errors[0];
          var msg = (first && first.error && (first.error.message || (first.error.data && first.error.data.description))) || "Não foi possível adicionar os itens.";
          this.showError(msg);
          if (theme.notification && theme.notification.error) theme.notification.error("Personalizador", msg);
          return;
        }

        this.dispatchEvent(new CustomEvent("glasses:added", { bubbles: true, detail: { destino: destino, result: result } }));
        this.close();
        this.state = this.defaultState();
        this.render();
        if (destino === "checkout") window.location.href = "/checkout";
        if (destino === "carrinho") window.location.href = this.dataset.cartUrl || "/cart";
      } catch (err) {
        this.showError(err.message || "Não foi possível concluir.");
        if (theme.notification && theme.notification.error) theme.notification.error("Personalizador", err.message || "Erro ao adicionar");
      } finally {
        this._submitting = false;
        if (loading) loading.style.display = "none";
        this.renderFooter();
      }
    }

    destroy() {
      document.removeEventListener("focus", this._focusHandler, true);
      document.body.classList.remove("zl-open", "glasses-customizer-open");
    }
  }

  if (window.customElements && !customElements.get("glasses-customizer")) {
    customElements.define("glasses-customizer", GlassesCustomizer);
  }
})();
